import { CoverageTypeEnumSimple } from '@global/infrastructure/enums/coverage-type.enum';

import { CoverageTypeToNamesMap, CoverageTypeToBookletNamesMap } from '@ren/infrastructure/configs/premium-cover.config';
import { JourneyFeaturesConfig } from '@ren/infrastructure/configs/journey-features.config';
import { environment } from '@env/environment';

export class CustomHelpers {

  static lookupCoverageTypeToName = (coverType: CoverageTypeEnumSimple) => CustomHelpers.lookupByKeyFromMapper(CoverageTypeToNamesMap, coverType);

  static lookupCoverageTypeToBookletName = (coverType: CoverageTypeEnumSimple) => CustomHelpers.lookupByKeyFromMapper(CoverageTypeToBookletNamesMap, coverType);

  static redirectToExternalUrl(url: string) {
    const isApp = localStorage.getItem('isApp');
    if (isApp === 'true') {
      localStorage.setItem('isApp', 'false');
      window.location.href = `app.${environment?.brand_copy.brandSimple}.com://landing`;
    } else {
      const baseUrl = location.origin || `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}`;
      window.location.href = `${baseUrl}${url}`;
    }
  }

  static redirectToRejectUrl() {
    window.location.href = `${location.href.split(location.pathname)[0]}/car/renew-policy/${JourneyFeaturesConfig.reviewInitial.path}`;
  }

  static removeNullEntriesV2<T>(obj: T): T {
    const acc: Partial<T> = {};
    for (const key in obj) {
      if (obj[key] !== null) { acc[key] = obj[key]; }
    }
    return acc as T;
  }

  private static lookupByKeyFromMapper<K, V>(mapper: Map<K, V>, key: K): V {
    return mapper.get(key) || null;
  }

  static formatDiscountCode(code: string) {
    return (
      code === 'MCD' ? 'Multicar discount' :
      code === 'XSELL' ? 'Multi product discount' :
      code === '0LEGAL' ?  'Free Legal Cover' :
      code === 'MIGXSELL' ? 'Multi product discount' :
      code === 'MIGMCD' ?  'Multicar discount' :
      code === 'MIGXSELL' ? 'Multi product discount' :
      code === 'MIGSTAFFMOT' ? 'Staff discount' :
      code === 'DLGSTAFFMOT' ? 'Staff discount' :
      code === 'WEBMCD' ? 'Multicar discount' :
      code === 'MTPOL' ? 'Multi-policy discount' :
      code === 'COMPETITORPRICE' ? 'Policy discount' :
      code === 'NOCOMPETITORPRICE' ? 'Policy discount' :
      code
    );
  }
}
